import React, {Component} from "react";
import Button from "antd/es/button";
import {inject, observer} from "mobx-react";


@inject('translationsStore', 'connectionRequestsStore')
@observer
export default class Success extends Component {
  componentDidMount() {
    return this.props.connectionRequestsStore.setConnectionRequests([]);
  }

  render() {
    const {translationsStore} = this.props;

    return (
      <div>
        <h3>{translationsStore.translate('connectionRequests.checkout.success.title')}</h3>
        <div className="CheckoutContainer">
          <p>{translationsStore.translate('connectionRequests.checkout.success.message1')}</p>

          <p>{translationsStore.translate('connectionRequests.checkout.success.message2')}</p>

          <p>{translationsStore.translate('connectionRequests.checkout.success.message3')}</p>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <Button
            style={{width: 'auto'}}
            onClick={this.props.onCancel}
            type="custom"
          >{translationsStore.translate('connectionRequests.checkout.success.cancel')}</Button>
          <Button
            style={{width: 'auto'}}
            onClick={this.props.onNext}
            type="primary"
          >{translationsStore.translate('connectionRequests.checkout.success.confirm')}</Button>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/CheckoutPopup/Success.js